module.exports = __webpack_public_path__ + "img/logo.d3ac28b7.png";